import React from 'react';
import { getFeatureFlagFilter, useFeatureFlags } from '@ApplicationWide/feature-flags';

const LoginPage = React.lazy(() => import('../../pages/Auth/LoginPage'));
const ForgotPasswordPage = React.lazy(() => import('../../pages/Auth/ForgotPasswordPage'));

const authRoutes = [
  { to: '/login/:temp?', route: '/login/:temp?', component: LoginPage },
  { to: '/forgot-password', route: '/forgot-password', component: ForgotPasswordPage },
];

export const useAvailableAuthRoutes = () => {
  const featureFlags = useFeatureFlags();
  return authRoutes.filter(getFeatureFlagFilter(featureFlags));
};
